import { render, staticRenderFns } from "./ForgetPasswordMain.vue?vue&type=template&id=133ea198&"
import script from "./ForgetPasswordMain.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports